/**
 * @generated SignedSource<<7076f91083a0dcbc98490bdf4d9b31f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateComponentsLockedStatusByProgramIdInput = {
  clientMutationId?: string | null | undefined;
  locked: boolean;
  programId: string;
};
export type CurriculumEditScreenComponentsLockedStatusMutation$variables = {
  input: UpdateComponentsLockedStatusByProgramIdInput;
};
export type CurriculumEditScreenComponentsLockedStatusMutation$data = {
  readonly updateComponentsLockedStatusByProgramId: {
    readonly components: ReadonlyArray<{
      readonly id: string;
      readonly locked: boolean;
    }>;
  } | null | undefined;
};
export type CurriculumEditScreenComponentsLockedStatusMutation = {
  response: CurriculumEditScreenComponentsLockedStatusMutation$data;
  variables: CurriculumEditScreenComponentsLockedStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateComponentsLockedStatusByProgramIdPayload",
    "kind": "LinkedField",
    "name": "updateComponentsLockedStatusByProgramId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Component",
        "kind": "LinkedField",
        "name": "components",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locked",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CurriculumEditScreenComponentsLockedStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CurriculumEditScreenComponentsLockedStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e91812fcdc798ab52940226965a23c09",
    "id": null,
    "metadata": {},
    "name": "CurriculumEditScreenComponentsLockedStatusMutation",
    "operationKind": "mutation",
    "text": "mutation CurriculumEditScreenComponentsLockedStatusMutation(\n  $input: UpdateComponentsLockedStatusByProgramIdInput!\n) {\n  updateComponentsLockedStatusByProgramId(input: $input) {\n    components {\n      id\n      locked\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0aa291f2e0962ee38fc487b43e2a4327";

export default node;
